var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoute(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 10C26.7909 10 25 11.7909 25 14V34C25 38.4183 21.4183 42 17 42C12.5817 42 9 38.4183 9 34V12H13V34C13 36.2091 14.7909 38 17 38C19.2091 38 21 36.2091 21 34V14C21 9.58172 24.5817 6 29 6C33.4183 6 37 9.58172 37 14V34H33V14C33 11.7909 31.2091 10 29 10Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7275 6.96101C11.9557 5.638 10.0441 5.638 9.27239 6.96101L5.75446 12.9917C4.97669 14.3251 5.93843 15.9995 7.48202 15.9995H14.5179C16.0615 15.9995 17.0232 14.3251 16.2454 12.9917L12.7275 6.96101Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9999 29.9995C31.6862 29.9995 28.9999 32.6858 28.9999 35.9995C28.9999 39.3132 31.6862 41.9995 34.9999 41.9995C38.3136 41.9995 40.9999 39.3132 40.9999 35.9995C40.9999 32.6858 38.3136 29.9995 34.9999 29.9995ZM32.9999 35.9995C32.9999 34.8949 33.8954 33.9995 34.9999 33.9995C36.1045 33.9995 36.9999 34.8949 36.9999 35.9995C36.9999 37.1041 36.1045 37.9995 34.9999 37.9995C33.8954 37.9995 32.9999 37.1041 32.9999 35.9995Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default __webpack_public_path__ + "static/media/route.f0571aa5504fc71a2d1ce8a001df5ef8.svg";
export { ForwardRef as ReactComponent };